// test1693
(1693 && 0);
